import { render, staticRenderFns } from "./WebCam.vue?vue&type=template&id=6045a32e&scoped=true&"
import script from "./WebCam.vue?vue&type=script&lang=js&"
export * from "./WebCam.vue?vue&type=script&lang=js&"
import style0 from "./WebCam.vue?vue&type=style&index=0&id=6045a32e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045a32e",
  null
  
)

export default component.exports